module.exports = __webpack_public_path__ + "img/gartek-portfolio-performing-arts.a9e9f938.jpeg";